module.exports = __webpack_public_path__ + "static/media/scroll4_phone3.6252973c.png";